import axios from "axios";

const API_BASE_URL =
    process.env.REACT_APP_API_URL || window.location.origin || "";
const TOKEN_KEY = "auth_token";
const USER_KEY = "user_info";

class AuthService {
    constructor() {
        // Set up axios interceptor to add auth token to requests
        axios.interceptors.request.use(
            (config) => {
                const token = this.getToken();
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Set up axios interceptor to handle auth errors
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 401) {
                    // Don't redirect if we're already on login page or during login attempt
                    const isLoginPage = window.location.pathname === '/login';
                    const isLoginRequest = error.config?.url?.endsWith('/auth/login');
                    
                    if (!isLoginPage && !isLoginRequest) {
                        this.logout();
                        window.location.href = "/login";
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    async login(username, password) {
        try {
            const response = await axios.post(`${API_BASE_URL}/auth/login`, {
                username,
                password,
            });

            const { access_token, user } = response.data;
            localStorage.setItem(TOKEN_KEY, access_token);
            localStorage.setItem(USER_KEY, JSON.stringify(user));
            return { success: true, user };
        } catch (error) {
            return {
                success: false,
                error: error.response?.data?.detail || "Login failed",
            };
        }
    }

    logout() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    }

    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    }

    getUser() {
        const userStr = localStorage.getItem(USER_KEY);
        return userStr ? JSON.parse(userStr) : null;
    }

    async getCurrentUser() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/user`);
            return response.data;
        } catch (error) {
            console.error("Failed to get current user:", error);
            return null;
        }
    }

    isAuthenticated() {
        return !!this.getToken();
    }
}

export const authService = new AuthService();
